module.exports = function removeSpans(str = "") {
  str = str.replace(/<span(.*?)>/g, "");
  str = str.replace(/<\/span>/g, "");
  return str;
};
